import * as React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

export interface IMultiselectOptionType {
    label: string;
    value?: any;
    options?: IMultiselectOptionType[];
}

export type IProps = any;
export type IPropsAsync = any;
type IProp = any;

// FIXME:
// No clue how to restyle this into bulma form style, seems impossible to override the built-in styles
// Apparently you can completely disable the blue outline, but not override it...
const styleOverrides = {
    control: (styles: any, { isHovered }: { isHovered: boolean }) => ({
        ...styles,
        border: `1px solid ${isHovered ? '#c7d4dc' : '#d6e2ea'}`,
        boxShadow: 'none',
    }),
    valueContainer: (styles: any) => ({
        ...styles,
        boxShadow: 'none !important',
        border: 'none !important',
    }),
    input: (styles: any) => ({
        ...styles,
        boxShadow: 'none !important',
        border: 'none !important',
    }),
    multiValue: (styles: any) => ({
        ...styles,
        backgroundColor: '#dbdbdb !important',
    }),
    multiValueLabel: (styles: any) => ({
        ...styles,
        color: '#000000 !important',
    }),
    multiValueRemove: (styles: any) => ({
        ...styles,
        color: '#000000 !important',
        ':hover': {
            backgroundColor: '#c4c4c4 !important',
            color: '#000000 !important',
        },
    }),
};

/*
 * homepage: https://react-select.com/home
 * github: https://github.com/JedWatson/react-select
 * typings: https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/react-select
 */
export default class MultiSelect extends React.Component<any> {
    public render() {
        const { cy, async, styles, ...multiProps } = this.props as any;

        return (
            <>
                <div data-cy={cy}>
                    {(async && (
                        <AsyncSelect
                            className="react-select-container"
                            classNamePrefix="react-select"
                            styles={{ ...styleOverrides, ...styles }}
                            {...multiProps}
                        />
                    )) || (
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{ ...styleOverrides, ...styles }}
                                {...multiProps}
                            />
                        )}
                </div>
            </>
        );
    }
}
